<div class="z-text-input-wrapper z-money" [ngClass]="containerStyleClass" [formGroup]="formGroup.form">
  <z-label [id]="id" [text]="label"></z-label>

  <p-inputNumber
    [formControlName]="fieldName"
    [format]="true"
    [showButtons]="false"
    mode="currency"
    [currency]="currency"
    [currencyDisplay]="currencyDisplay"
    [useGrouping]="useGrouping"
    [minFractionDigits]="minFractionDigits"
    [maxFractionDigits]="maxFractionDigits"
    [min]="min"
    [max]="max"
    [size]="size"
    [allowEmpty]="allowEmpty"
    [styleClass]="styleClass"
    [inputStyleClass]="inputStyleClass"
    [inputId]="id"
    [placeholder]="placeholder"
    [showClear]="clearButton"
    (onClear)="onClear($event)"
    [readonly]="readonly"
    [maxlength]="maxlength"
  ></p-inputNumber>

  <z-hint *ngIf="hint" [text]="hint"></z-hint>

  <z-validation *ngIf="displayValidationErrors" [control]="this.formGroup.form.controls[this.fieldName]"></z-validation>
</div>
